<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- 路由出口：匹配的路由组件会渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script setup>
// 无需额外代码，只要挂载了 Router，<router-view> 就会生效
</script>

<style>
/* 全局样式可保留 */
</style>